import { name } from "./block.json";

import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
	const swiperHTMLElement = block.querySelector<HTMLElement>('.swiper');

	if (!swiperHTMLElement) {
		return;
	}

	const numSlides = swiperHTMLElement.querySelectorAll('.swiper-slide').length;

	const nextEl = block.querySelector<HTMLElement>('.swiper-button-next');
	const prevEl = block.querySelector<HTMLElement>('.swiper-button-prev');

	// init Swiper:
	const swiper = new Swiper(swiperHTMLElement, {
		speed: 1500,
		loop: numSlides > 1,
		//loopAddBlankSlides: true,
		//centerInsufficientSlides: true,
		breakpointsBase: 'container',
		touchEventsTarget: 'container',

		slidesPerView: 1,
		spaceBetween: 20,

		centerInsufficientSlides : true,
		centeredSlidesBounds : true,

		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 2,
				spaceBetween: 20,
				loop: numSlides > 2,
			},
			// when window width is >= 480px
			480: {
				slidesPerView: 3,
				spaceBetween: 30,
				loop: numSlides > 3,
			},
			// when window width is >= 640px
			640: {
				slidesPerView: 4,
				spaceBetween: 40,
				loop: numSlides > 4,
			},
			// when window width is >= 880px
			880: {
				slidesPerView: 5,
				spaceBetween: 40,
				loop: numSlides > 5,
			},
			// when window width is >= 1120px
			1120: {
				slidesPerView: 6,
				spaceBetween: 40,
				loop: numSlides > 6,
			}
		},
		// configure Swiper to use modules
		modules: [Autoplay, Navigation],

		autoplay: {
			delay: 1500,
			pauseOnMouseEnter: true,
			waitForTransition: true,
		},

		navigation: {
			nextEl,
			prevEl,
		},
	});

	// swiper.slides
	// swiper.loopDestroy()
	// swiper.loop

	// justify-content: center;
}
